import { render, staticRenderFns } from "./ChartTable.vue?vue&type=template&id=af52f650"
import script from "./ChartTable.vue?vue&type=script&lang=js"
export * from "./ChartTable.vue?vue&type=script&lang=js"
import style0 from "./ChartTable.vue?vue&type=style&index=0&id=af52f650&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports